import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z","key":"svg-0"}],["path",{"d":"M9 8l0 8","key":"svg-1"}],["path",{"d":"M9 12l6 0","key":"svg-2"}],["path",{"d":"M15 8l0 8","key":"svg-3"}]]

const IconHelicopterLanding = createReactComponent('outline', 'helicopter-landing', 'HelicopterLanding', __iconNode);

export default IconHelicopterLanding;